import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomImageCropper from 'designer/component/element/ImageCropper'

export const ImageCropperSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomImageCropper {...props} />
  </DragElementWrapper>
)

export const ImageCropperDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomImageCropper {...props} />
  </ElementWrapper>
)

export const imageCropperTester = rankWith(1000, scopeEndsWith('imageCropper'))
